var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsos-incidents-header"},[_c('h3',{staticStyle:{"margin-bottom":"0px","padding-bottom":"0px"}},[_vm._v(" Incidents ")])])
}]

export { render, staticRenderFns }